module.exports = __webpack_public_path__ + "static/Verne4-a0ff0e3f67e518b012a64bbd85b8ee2e.webp";